import { AfterViewInit, ChangeDetectionStrategy, Component, computed, inject, viewChildren, ViewEncapsulation } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialog } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';
import { AppService } from '@src/suite/app.service';
import { ObjectTypes } from '@src/suite/common/enums/object-types';
import { GlobalTablesService } from '@src/suite/common/services/global-tables-service';
import { NomWebServicesJson } from '@src/suite/common/services/nom-web-services-json';
import { VisualStateService } from '@src/suite/common/services/visual-state-service';
import { OpenFullscreenModalActions } from '@src/suite/common/store/fullscreen/actions/fullscreen.actions';
import { selectDirectionality } from '@src/suite/common/store/hello-results/hello-results.selectors';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { selectCurrentViewState } from '@src/suite/common/store/navigation/selectors/viewstate.selectors';
import { PlaybookApiActions } from '@src/suite/common/store/playbook/playbook.actions';
import { RecordHttpActions } from '@src/suite/common/store/records/records.actions';
import { selectTopicTemplates } from '@src/suite/common/store/records/records.selectors';

@Component({
    selector: 'st-base-main-cta',
    imports: [MatButtonToggleModule, MatListModule, MatMenuModule, MatTooltipModule],
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class BaseMainCtaComponent implements AfterViewInit {
    store = inject(Store);
    appService = inject(AppService);
    visualStateService = inject(VisualStateService);
    nomWebServicesJson = inject(NomWebServicesJson);
    globalTablesService = inject(GlobalTablesService);
    dialog = inject(MatDialog);

    readonly templateMenus = viewChildren(MatMenuTrigger);

    public topicEditable = true;
    public storyEditable = true;

    readonly viewState = computed(() => this.store.selectSignal(selectCurrentViewState)());
    readonly topicTemplates = this.store.selectSignal(selectTopicTemplates);
    readonly languageSettings = this.store.selectSignal(selectI18N)();

    readonly viewStateLoaded = computed(() => {
        return !!this.viewState();
    });

    readonly topicTemplatesDisabled = computed(() => {
        return !this.topicTemplates().length || !this.topicEditable;
    });

    readonly directionality = computed(() => {
        return this.store.selectSignal(selectDirectionality)();
    });

    ngAfterViewInit() {
        this.topicEditable = this.globalTablesService.securityPrivileges[this.nomWebServicesJson.PSTGroup].topic.write;
        this.storyEditable = this.globalTablesService.securityPrivileges[this.nomWebServicesJson.HelloResults.HomeProgram].story.write;
    }

    onNewTopicClicked() {
        this.store.dispatch(
            OpenFullscreenModalActions.initCreateNewRecordFullscreen({
                recordType: ObjectTypes.TOPIC,
            })
        );
    }
    onTopicTemplateMenuOpened() {
        this.store.dispatch(PlaybookApiActions.loadTopicTemplates());
    }

    selectTopicTemplate(template: StorytellingTopicRecord) {
        if (!template.isDeleted) {
            this.store.dispatch(
                OpenFullscreenModalActions.initCreateNewRecordFullscreen({
                    recordTemplate: template,
                    recordType: template.Type,
                })
            );
        }
    }
    deleteTemplate(data: StorytellingTopicRecord | StorytellingStoryRecord) {
        this.store.dispatch(RecordHttpActions.deleteRecordTemplate({ guid: data.Guid, recordType: data.Type }));
        this.templateMenus()?.forEach(menu => menu.closeMenu());
    }
}
